<div [style.position]="'relative'">
  <input
    #sinInput
    *ngIf="!showMaskedSIN"
    class="sin-input"
    type="text"
    inputmode="text"
    autocomplete="off"
    [attr.id]="controlId"
    [placeholder]="placeholder"
    [maskito]="maskOptions"
    [value]="value"
    [disabled]="disabled"
    [ngClass]="{
      'error-border': error,
      'masked-while-typing': maskWhileTyping && !showingSIN && !!value
    }"
    (input)="handleInput($event)"
    (blur)="handleBlur()" />

  <div
    *ngIf="maskWhileTyping && !showMaskedSIN && !showingSIN && !!value"
    aria-hidden="true"
    class="sin-input-typing-mask"
    [innerHTML]="getMaskedDisplayString()"></div>

  <div
    #hiddenSIN
    [hidden]="!showMaskedSIN"
    class="sin-input sin-input-hidden"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.contenteditable]="false"
    [ngClass]="{
      'error-border': error,
      disabled: disabled
    }"
    [ngStyle]="{ 'padding-right': showHideSINButton ? '2rem' : '0' }"
    (mouseenter)="showEditableSINInput()"
    (click)="showEditableSINInput(true)"
    (focus)="showEditableSINInput(true)"></div>
  <button
    class="eye"
    aria-label="Show SIN"
    i18n-aria-label
    [attr.aria-pressed]="isSINVisible()"
    (click)="toggleShowHide()"
    [disabled]="disabled"
    type="button"
    [ngClass]="{
      opened: isSINVisible() && !!value,
      closed: !isSINVisible() || !value,
      error: error,
      disabled: disabled
    }"></button>
</div>
